// extracted by mini-css-extract-plugin
export default {"PurchasePaymentsPage":"PurchasePaymentsPage_PurchasePaymentsPage__whdNW"};